import ZoomScroll from './ZoomScroll';

export default {
  __init__: [ 'zoomScroll' ],
  zoomScroll: [ 'type', ZoomScroll ]
};